import { FC, ReactNode, useEffect, useState } from "react";
import { MasterDataTable } from "../../../components/DataTable/MasterDataTable";
import { TableColumn } from "react-data-table-component";
import { Merchant } from "../../../interfaces/Merchant";
import { AddMerchant } from "../../../components/Merchants/AddMerchant";
import { UpdateMerchant } from "../../../components/Merchants/UpdateMerchant";
import { DeleteMerchant } from "../../../components/Merchants/DeleteMerchant";
import { UserModel } from "../../modules/auth/models/UserModel";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "../../../setup";
import { useSettingsStore } from "../../../stores/SettingsStore";
import { CustomField } from "../../../interfaces/Settings";
import moment from "moment";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DataTableExport } from "../../../components/DataTable/DataTableExport";
import { FilterMerchant } from "../../../components/Merchants/FilterMerchant";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { checkWhatsapp, updateWhatsapp } from "../../../api/Whatsapp";
import useAccessToken from "../../../hooks/AccessToken";
import Swal from "sweetalert2";
import { useLocation } from "react-router";
import { UpdatePhoneMerchant } from "../../../components/Merchants/UpdatePhoneMerchant";
import { useIntl } from "react-intl";
import { DataTableImport } from "../../../components/DataTable/DataTableImport";
import { customThousandSeparatorDot, sortColumnDatatable } from "../../../functions/general";
import useSWR, { mutate } from "swr";
import { Link } from "react-router-dom";
import { DetailMerchant } from "../../../components/Merchants/DetailMerchant";
import { AddReimbursement } from "../../../components/Reimbursement/AddReimbursement";
import { MergeMerchant } from "../../../components/Merchants/MergeMerchant";
import { usePipelineStore } from "../../../stores/PipelineStore";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useModalEffect from "../../../hooks/useModalEffect";
import { useDataTableStore } from "../../../stores/DataTableStore";
import { useMerchantStore } from "../../../stores/MerchantStore";
import axios from "axios";
import { useCustomeStore } from "../../../stores/CustomeStore";
import { VirtualizedSelectOption, VirtualizedSelectOptionsType } from "../../../components/Select/SelectVirtualized";
import { useMeetingStore } from "../../../stores/MeetingsStore";
import { isAllowAddReimburse } from "../../../functions/reimbursement";
import useDynamicTab from "../../../hooks/useDynamicTab";
import { ExpandableElement } from "../../../components/General/ExpandableElement";
import { useReimbursementStore } from "../../../stores/ReimbursementStore";
import { ModalAttachmentCustomField } from "../../../components/ModalGeneral/ModalAttachmentCustomField";
import { MerchantPICLog } from "./MerchantPICLog";
import { DatePicker } from "rsuite";
import useCalendarLocale from "../../../hooks/CalendarLocale";
import LabelTooltip from "../../../components/General/LabelTooltip";
import { checkIsCompanyVaporesia } from "../../../functions/customCase";

export interface MerchantVirtualizedSelectOption extends VirtualizedSelectOption {
    nameCustomField?: string
    nameTemplate?: string
    nameMerchant?: string
    idCustomField?: string
    idTemplate?: string
    idMerchant?: string
    customFieldCompanyCode?: string
    idMerchantLink?: string
}

export interface MerchantVirtualizedSelectOptionsType extends VirtualizedSelectOptionsType {
    nameCustomField?: string
    nameTemplate?: string
    nameMerchant?: string
    idCustomField?: string
    idTemplate?: string
    idMerchant?: string
    customFieldCompanyCode?: string
    idMerchantLink?: string
}

const MasterMerchant: FC = () => {
    const API_URL = process.env.REACT_APP_API_URL
    const { remainingLimitMonth, remainingLimitYear } = useReimbursementStore()
    const { companyId } = useCustomeStore()
    const { multiPipelines } = usePipelineStore()
    const { multiMeetings } = useMeetingStore()
    const [showAddReimbursementModal, setShowAddReimbursementModal] = useState<boolean>(false);
    const [showUpdatePhoneModal, setShowUpdatePhoneModal] = useState<boolean>(false);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showMergeModal, setShowMergeModal] = useState<boolean>(false);
    const [showAttachmentCustomField, setShowAttachmentCustomFieldModal] = useState<boolean>(false);
    const [showDetailModal, setShowDetailModal] = useState<boolean>(false);
    const [key, setKey] = useState<string>('');
    const [url, setUrl] = useState<string | string[]>('');
    const [merchant, setMerchant] = useState<Merchant>();
    const { settings } = useSettingsStore()
    const [customFields, setCustomFields] = useState<CustomField>({})
    const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [manageColumns, setManageColumns] = useState<TableColumn<Merchant>[]>([]);
    const token = useAccessToken()
    const { multiMerchants, setSelectMultiMerchant, selectMultiMerchant } = useMerchantStore()
    const { pathname } = useLocation()
    const [codeUrl, setCodeUrl] = useState((pathname).split('/').pop());
    const [displayMode, setDisplayMode] = useState<string>('table');
    const calendarLocale = useCalendarLocale();
    const [date, setDate] = useState<Date>(new Date());

    const { masterDateRange } = useDataTableStore()
    const intl = useIntl()

    const fetcher = async (url: string) => {
        const response = await axios.get(url, {
            headers: {
                'X-Auth-token': token,
            },
        });
        return response.data.data;
    };

    const { data: labels = [], error: labelsError, isLoading: labelsLoading } = useSWR(`${API_URL}labels?usableBy[]=merchant`, fetcher)

    const handleClick = (menuId: string) => {
        setOpenMenuId(menuId);
    };
    const handleClose = () => {
        setOpenMenuId(null);
    };

    const onRowClicked = (row: Merchant) => {
        setMerchant(row)
        setShowDetailModal(true);
    };

    const updateWhatsappValid = async (id: string, phone: string, res: boolean) => {
        try {
            const response = await updateWhatsapp(id, res, token)
            if (response.data.success) {
                if (res) {
                    if (user.data.is_superadmin) {
                        window.open(`https://api.whatsapp.com/send?phone=${phone.replace("+", "")}`)
                    }
                }
            }
        } catch (error) {

        }
    }

    const redirectWhatsappValid = async (id: string, phone: string) => {
        try {
            const response = await checkWhatsapp(phone.replace("+", ""))
            if (!response.data.result.exists) {
                updateWhatsappValid(id, phone, response.data.result.exists)
            } else {
                if (user.data.is_superadmin) {
                    window.open(`https://api.whatsapp.com/send?phone=${phone.replace("+", "")}`)
                }
            }
        } catch (error) {

        }
    }

    const redirectWhatsappNotValid = async (id: string, phone: string) => {
        try {
            const response = await checkWhatsapp(phone.replace("+", ""))
            if (response.data.result.exists) {
                updateWhatsappValid(id, phone, response.data.result.exists)
            } else {
                Swal.fire({
                    icon: "error",
                    title: intl.formatMessage({ id: 'FORM.VALIDATION.INVALID_NUMBER' }),
                    heightAuto: false,
                })
            }
        } catch (error) {

        }
    }

    let tableColumns: TableColumn<Merchant>[] = [
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }),
            center: true,
            width: '70px',
            id: 'fixedLeft',
            cell: (row) => {

                return (
                    <>
                        <IconButton
                            aria-label={`more-${row.id}`}
                            id={`menu-anchor-${row.id}`}
                            onClick={() => handleClick(row.id)}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            id={`menu-${row.id}`}
                            anchorEl={document.getElementById(`menu-anchor-${row.id}`)}
                            open={openMenuId === row.id}
                            onClose={handleClose}
                            disableScrollLock={true}
                        >
                            {
                                user.data.id === row.ownerId &&
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-labels" hidden={isAllowAddReimburse(remainingLimitYear, remainingLimitMonth)}>{intl.formatMessage({ id: "FORM.LABEL.LIMIT_REACHED" })}</Tooltip>} >
                                    <div style={{ display: 'inline-block', cursor: isAllowAddReimburse(remainingLimitYear, remainingLimitMonth) ? 'pointer' : 'not-allowed' }} >
                                        <MenuItem
                                            disabled={!isAllowAddReimburse(remainingLimitYear, remainingLimitMonth)}
                                            onClick={() => {
                                                if (isAllowAddReimburse(remainingLimitYear, remainingLimitMonth)) {
                                                    handleClose();
                                                    setShowAddReimbursementModal(true);
                                                    setMerchant(row);
                                                }
                                            }}
                                            style={{ pointerEvents: 'auto' }}
                                        >
                                            <i className="fa-plus fas fs-4 me-4"></i>
                                            <span>{intl.formatMessage({ id: 'FORM.ACTION.REIMBURSEMENTS' })}</span>
                                        </MenuItem>
                                    </div>
                                </OverlayTrigger>
                            }

                            <MenuItem>
                                <Link to={`${row.id}/pipelines/${multiPipelines[0]?.id}`} target="_blank" className="text-black w-100">
                                    <i className="fa-eye fas fs-4 me-4"></i>
                                    <span>Lihat {settings.pipeline_title}</span>
                                </Link>
                            </MenuItem>

                            <MenuItem>
                                <Link to={`${row.id}/meetings/${multiMeetings[0]?.id}`} target="_blank" className="text-black w-100">
                                    <i className="fas fa-eye fs-4 me-4"></i>
                                    <span>Lihat {settings.meeting_title}</span>
                                </Link>
                            </MenuItem>

                            {
                                (user.data.is_superadmin || user.data.permission_merchant_update !== 'NONE') &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    setShowUpdateModal(true);
                                    setMerchant(row);
                                }}>
                                    <i className="fa-edit fas fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.UPDATE' })}</span>
                                </MenuItem>
                            }

                            {/* {
                                settings.merchant_phone_can_be_changed &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    setShowUpdatePhoneModal(true);
                                    setMerchant(row);
                                }}>
                                    <i className="fa-edit fas fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.UPDATE_PHONE' })}</span>
                                </MenuItem>
                            } */}

                            {
                                (user.data.is_superadmin || user.data.permission_merchant_delete !== 'NONE') &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    setShowDeleteModal(true);
                                    setMerchant(row);
                                }}>
                                    <i className="fa-trash fas fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.DELETE' })}</span>
                                </MenuItem>
                            }

                            {
                                (user.data.is_superadmin || (user.data.permission_merchant_delete !== 'NONE' && user.data.permission_merchant_update !== 'NONE')) &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    setShowMergeModal(true);
                                    setMerchant(row);
                                }}>
                                    <i className="fa-object-group fas fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.MERGE_DATA' })}</span>
                                </MenuItem>
                            }
                        </Menu>
                    </>
                )
            },
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }))?.omit
        },
        {
            id: 'name',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME' }),
            style: { cursor: "pointer" },
            width: '200px',
            selector: row => row.name?.toLowerCase(),
            sortable: true,
            cell: row => {
                var labels = row?.labels?.map((label: any) => ({ text: label.name, color: label.color })) || [];

                return (
                    <div className="d-flex flex-row gap-2">
                        <div>
                            {row.name}
                        </div>
                        {selectMultiMerchant.isFeatureLabelEnabled && labels.length > 0 && (
                            <LabelTooltip data={labels}>
                                {labels}
                            </LabelTooltip>
                        )}
                    </div>
                )

            },
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME' }))?.omit
        },
        {
            id: 'pic',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PIC' }),
            style: { cursor: "pointer" },
            width: '200px',
            selector: row => row.ownerName?.toLowerCase(),
            sortable: true,
            cell: row => row.ownerName,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PIC' }))?.omit
        },
        {
            id: 'city',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CITY' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.cityName?.toLowerCase(),
            sortable: true,
            cell: row => row.cityName,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CITY' }))?.omit
        },
        {
            id: 'phone',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PHONE' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.phone,
            sortable: true,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PHONE' }))?.omit
        },
        {
            id: 'whatsapp',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.WHATSAPP' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.isWhatsappPhone,
            sortable: true,
            center: true,
            reorder: true,
            cell: row => {
                if (row.isWhatsappPhone) return <img alt='Banner' style={{ padding: "15px" }} onClick={() => redirectWhatsappValid(row.id, row.phone)} className='h-50px cursor-pointer' src={toAbsoluteUrl('/media/assets/checked.png')} />
                else return <img alt='Banner' style={{ padding: "15px" }} onClick={() => redirectWhatsappNotValid(row.id, row.phone)} className='h-50px cursor-pointer' src={toAbsoluteUrl('/media/assets/remove.png')} />
            },
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.WHATSAPP' }))?.omit
        },
        ...(checkIsCompanyVaporesia(companyId, user) ? [] : [
            {
                id: 'email',
                name: 'Email',
                style: { cursor: "pointer" },
                width: '150px',
                selector: (row: Merchant) => row.email as string,
                sortable: true,
                reorder: true,
                cell: (row: Merchant) => {
                    if (!row.email) {
                        return <p>-</p>
                    } else {
                        return <p className="mt-2">{row.email}</p>
                    }
                },
                omit: manageColumns.find(item => item.name === 'Email')?.omit
            },
        ]),
        {
            id: 'lastMeeting',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LAST_MEETING' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.lastMeetEnd,
            sortable: true,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LAST_MEETING' }))?.omit
        },
        {
            id: 'lastPipeline',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LAST_ADD_MERCHANT' }, { title: settings.pipeline_title }),
            style: { cursor: "pointer" },
            width: '200px',
            selector: row => row.lastLeadCreatedTime,
            sortable: true,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LAST_ADD_MERCHANT' }, { title: settings.pipeline_title }))?.omit
        },
        {
            id: 'countPipeline',
            name: user.data.company_id === companyId.yClinic ? intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PURCHASE_PACKAGE_COUNT' }) : intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.COUNT' }, { title: settings.pipeline_title }),
            style: { cursor: "pointer" },
            sortable: true,
            reorder: true,
            right: true,
            selector: row => user.data.company_id === companyId.yClinic ? row.leadsPurchasePackageCount || 0 : row.leadsCount,
            cell: row => {
                return <Link to={`${row.id}/pipelines/${multiPipelines[0]?.id}`} target="_blank" className="text-black">
                    <span className="text-primary cursor-pointer">{user.data.company_id === companyId.yClinic ? row.leadsPurchasePackageCount : row.leadsCount}</span>
                </Link>
            },
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.COUNT' }, { title: settings.pipeline_title }))?.omit
        },
        {
            id: 'countMeeting',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.COUNT' }, { title: settings.meeting_title }),
            style: { cursor: "pointer" },
            width: '200px',
            sortable: true,
            reorder: true,
            right: true,
            selector: row => row.meetingsCount,
            cell: row => {
                return <Link to={`${row.id}/meetings/${multiMeetings[0]?.id}`} target="_blank" className="text-black">
                    <span className="text-primary cursor-pointer">{row.meetingsCount}</span>
                </Link>
            },
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.COUNT' }, { title: settings.meeting_title }))?.omit
        },
        {
            id: 'creatorName',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CREATED_BY' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.creatorName?.toLowerCase(),
            sortable: true,
            cell: row => row.creatorName,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CREATED_BY' }))?.omit
        },
        {
            id: 'dateCreated',
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.TYPE.DATE_CREATED' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.dateCreated,
            sortable: true,
            cell: (row) => {
                return moment(row.dateCreated).format("DD MMM YYYY HH:mm")
            },
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.TYPE.DATE_CREATED' }))?.omit
        },
    ];

    const tableColumnsWithCustomFields: TableColumn<Merchant>[] = [
        ...tableColumns,
        ...Object.keys(customFields).map((key, index) => {
            if (customFields[key].type === 'number') {
                return {
                    name: customFields[key].name,
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? customThousandSeparatorDot(row.customFields[key] as unknown as number) : '-'
                    },
                    cell: (row: Merchant) => {
                        if (row.customFields && row.customFields[key]) {
                            return customThousandSeparatorDot(row.customFields[key] as unknown as number)
                        } else {
                            return '-'
                        }
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'date') {
                return {
                    id: key,
                    width: "150px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-';
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                    cell: (row: Merchant) => {
                        if (row.customFields && row.customFields[key]) {
                            return (
                                moment(row.customFields[key]).format("DD MMM YYYY")
                            )
                        } else {
                            return '-'
                        }
                    }
                };
            } else if (customFields[key].type === 'image' || customFields[key].type === 'images') {
                return {
                    id: key,
                    width: "70px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    center: true,
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-'
                    },
                    cell: (row: Merchant) => {
                        if (row.customFields && row.customFields[key]) {
                            return (
                                <span role="button" onClick={
                                    () => {
                                        setShowAttachmentCustomFieldModal(true);
                                        setMerchant(row);
                                        setKey(key);
                                        setUrl(row.customFields[key] as any);
                                    }
                                }>
                                    <i className="fa-eye fas fs-2"></i>
                                </span>
                            )
                        } else {
                            return '-'
                        }
                    },
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'file' || customFields[key].type === 'files' || customFields[key].type === 'video' || customFields[key].type === 'videos') {
                return {
                    id: key,
                    width: "70px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    center: true,
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-'
                    },
                    cell(row: Merchant) {
                        const fileUrl = row.customFields && row.customFields[key];
                        if (typeof fileUrl === "string") {
                            return fileUrl ? (
                                <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-active-color-primary btn-bg-light btn-icon btn-sm ms-2"
                                >
                                    <i className="float-end fa-file-invoice fas fs-3"></i>
                                </a>
                            ) : '-';
                        } else {
                            return fileUrl ? (
                                <span role="button" onClick={() => {
                                    setShowAttachmentCustomFieldModal(true);
                                    setMerchant(row);
                                    setKey(key);
                                    setUrl(fileUrl as string[]);
                                }}>
                                    <i className="float-end fa-file-invoice fas fs-3"></i>
                                </span>
                            ) : '-';
                        }
                    },
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'multiple' || customFields[key].type === 'multipleOption') {
                return {
                    id: key,
                    width: "150px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: Merchant) => {
                        const values = row.customFields && row.customFields[key] && row.customFields[key].toString()
                        if (customFields[key].type === 'multipleOption') {
                            return values ? (
                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                    <div>{values.split(',').join(', ')}</div>
                                </div>
                            ) : "-"
                        } else return values ? values.split(',').join(', ') : '-'
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'link') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: Merchant) => {
                        if (row.customFields && row.customFields[key]) {
                            return (
                                <a href={row.customFields[key] as string} rel="noreferrer" className="btn btn-active-light btn-outline btn-outline-default btn-sm text-gray-600" target="_blank">Lihat<i className="p-0 fa-external-link-alt fas fs-6 ms-2"></i></a>
                            )
                        } else return "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'serial') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: Merchant) => {
                        const values = row.customFields && row.customFields[key];
                        return values ? (values as string[]).join('') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'merchant') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: Merchant) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.merchant_name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'pipeline') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Merchant) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Merchant) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return (
                                <div className="d-flex flex-column">
                                    <span><b>{(values[0] as any).name}</b> / </span>
                                    <span>{(values[0] as any).nominal} / </span>
                                    <span>{moment((values[0] as any).dateCreated).format("DD MMM YYYY")}</span>
                                </div>
                            );
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'meeting') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Merchant) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Merchant) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => `${item.merchant_name} / ${moment(item.date_meet).format('DD MMM YYYY')} / ${item.meeting_status}`).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'user') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Merchant) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Merchant) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'link') {
                return {
                    id: key,
                    name: customFields[key].name,
                    cell: (row: Merchant) => {
                        if (row.customFields && row.customFields[key]) {
                            return (
                                <a href={row.customFields[key] as string} rel="noreferrer" className="btn btn-active-light btn-outline btn-outline-default btn-sm text-gray-600" target="_blank">{intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LINK' })}<i className="p-0 fa-external-link-alt fas fs-6 ms-2"></i></a>
                            )
                        } else return "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'dateTime') {
                return {
                    id: key,
                    name: customFields[key].name,
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-';
                    },
                    cell: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? moment(row.customFields[key]).format('DD MMM YYYY HH:mm') : '-'
                    },
                    sortable: true,
                    reorder: true,
                    width: "200px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'dateTimeRange') {
                return {
                    id: key,
                    name: customFields[key].name,
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? (row.customFields[key] as string[]).map((item: any) => item).join(' - ') : '-'
                    },
                    width: "200px",
                    cell: (row: Merchant) => {
                        if (row.customFields && row.customFields[key]) {
                            return Array.isArray(row.customFields[key]) && (row.customFields[key] as string[]).map((item: any) => moment(item).format('DD MMM YYYY HH:mm')).join(' - ')
                        } else {
                            return '-'
                        }
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'time') {
                return {
                    id: key,
                    name: customFields[key].name,
                    width: '150px',
                    selector: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? moment(row.customFields[key]).format('HH:mm') : '-';
                    },
                    cell: (row: Merchant) => {
                        return row.customFields && row.customFields[key] ? moment(row.customFields[key]).format('HH:mm') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'product') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: any) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: any) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.product_name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'option') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Merchant) => {
                        const fieldValue = row.customFields && (row.customFields[key] as string);
                        const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                            ? '-'
                            : fieldValue;

                        return displayValue || '-';
                    },
                    cell: (row: Merchant) => {
                        const values = row.customFields && row.customFields[key] && row.customFields[key].toString();
                        return values ? (
                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                {values.split('\n').map((line, idx) => (
                                    <div key={idx}>{line}</div>
                                ))}
                            </div>
                        ) : "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns[index + 25] ? manageColumns[index + 25].omit : false
                };
            } else if (customFields[key].type === 'paragraph') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Merchant) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Merchant) => {
                        const values = row.customFields && row.customFields[key] && row.customFields[key].toString();
                        return values ? (
                            <ExpandableElement
                                content={
                                    <div style={{ whiteSpace: 'pre-wrap' }}>
                                        {values}
                                    </div>
                                }
                                maxHeight={100}
                            />
                        ) : "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            }
            return {
                id: key,
                width: "150px",
                name: customFields[key].name,
                style: { cursor: "pointer" },
                selector: (row: Merchant) => {
                    // Check if row.customFields is defined and not null
                    const fieldValue = row.customFields && row.customFields[key];

                    // Check if fieldValue is an object and not null
                    const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                        ? '-'
                        : fieldValue;

                    return (displayValue as string)?.toLowerCase() || '-';
                },
                allowOverflow: true,
                sortable: true,
                omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                cell: (row: Merchant) => {
                    // Check if row.customFields is defined and not null
                    const fieldValue = row.customFields && row.customFields[key];

                    // Check if fieldValue is an object and not null
                    const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                        ? '-'
                        : fieldValue;

                    return displayValue || '-';
                },
                reorder: true
            };
        }),
    ];

    if (user.data.company_id === companyId.esb) {
        const companyCodeIndex = tableColumnsWithCustomFields.findIndex(col => (col.name as string)?.toLowerCase() === "company code");
        const nameIndex = tableColumnsWithCustomFields.findIndex(col => col.name === intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.NAME" }));
        companyCodeIndex !== -1 && sortColumnDatatable(tableColumnsWithCustomFields, companyCodeIndex, nameIndex);

        const companyNameIndex = tableColumnsWithCustomFields.findIndex(col => (col.name as string)?.toLowerCase() === "company name");
        const nameIndex2 = tableColumnsWithCustomFields.findIndex(col => col.name === intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.NAME" }));
        companyNameIndex !== -1 && sortColumnDatatable(tableColumnsWithCustomFields, companyNameIndex, nameIndex2);
    }

    if (user.data.company_id === companyId.marketz) {
        const dateCreatedIndex = tableColumnsWithCustomFields.findIndex(col => (col.name as string) === intl.formatMessage({ id: 'MASTERS.DATATABLE.TYPE.DATE_CREATED' }));
        const nameIndex = tableColumnsWithCustomFields.findIndex(col => col.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME' }));
        dateCreatedIndex !== -1 && sortColumnDatatable(tableColumnsWithCustomFields, dateCreatedIndex, nameIndex);

        const countLeadIndex = tableColumnsWithCustomFields.findIndex(col => (col.name as string) === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.COUNT' }, { title: settings.pipeline_title }));
        const nameIndex2 = tableColumnsWithCustomFields.findIndex(col => col.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME' }));
        countLeadIndex !== -1 && sortColumnDatatable(tableColumnsWithCustomFields, countLeadIndex, nameIndex2);
    }

    let actions: ReactNode[] = []
    if (user.data.is_allowed_export_excel) {
        actions.push(<DataTableExport source={"Merchant"} columns={manageColumns} dateStart={masterDateRange.merchant?.startDate as string} dateEnd={masterDateRange.merchant?.endDate as string} />)
    }

    if (user.data.permission_merchant_create !== 'NONE') {
        actions.push(
            <DataTableImport source={"template-merchant"} masterLabels={labels} />,
            <AddMerchant />
        );
    }

    actions.push(<FilterMerchant manageColumns={manageColumns} setManageColumns={setManageColumns} />);

    useEffect(() => {
        setManageColumns(tableColumnsWithCustomFields);
    }, [customFields])

    useModalEffect({
        showModal: showAddReimbursementModal,
        setShowModal: setShowAddReimbursementModal,
        modalId: `add-reimbursement-modal`
    })

    useModalEffect({
        showModal: showUpdatePhoneModal,
        setShowModal: setShowUpdatePhoneModal,
        modalId: `update-phone-merchant-modal-${merchant?.id}`
    })

    useModalEffect({
        showModal: showUpdateModal,
        setShowModal: setShowUpdateModal,
        modalId: `update-merchant-modal`
    })

    useModalEffect({
        showModal: showDeleteModal,
        setShowModal: setShowDeleteModal,
        modalId: `delete-merchant-modal-${merchant?.id}`
    })

    useModalEffect({
        showModal: showMergeModal,
        setShowModal: setShowMergeModal,
        modalId: `merge-merchant-modal-${merchant?.id}`
    })

    useModalEffect({
        showModal: showAttachmentCustomField,
        setShowModal: setShowAttachmentCustomFieldModal,
        modalId: `attachments-custom-field-modal-${merchant?.id}`
    })

    useModalEffect({
        showModal: showDetailModal,
        setShowModal: setShowDetailModal,
        modalId: `detail-merchant-modal-${merchant?.id}`
    })

    useEffect(() => {
        if (codeUrl && multiMerchants.length > 0) {
            const data = multiMerchants.find(item => item.id === codeUrl)
            setSelectMultiMerchant(data!)
            setCustomFields(data?.customFields!);
        }
    }, [multiMerchants, codeUrl])

    useEffect(() => {
        if (codeUrl !== (pathname).split('/').pop()) {
            setCodeUrl((pathname).split('/').pop()!)
        }
    }, [pathname])

    useDynamicTab({ title: `${settings.merchant_title} | CRM WooBlazz` });

    return (
        <>
            <div className="row justify-content-between mb-3">
                <div className="col-lg-6 col-sm-6 col-xl-6" style={{ alignSelf: "center" }}>
                    <ol className="text-muted breadcrumb fs-6 fw-bold">
                        <li className="text-dark text-muted breadcrumb-item">{settings.merchant_title}</li>
                        <li className={`text-dark breadcrumb-item ${displayMode === 'pic-log' ? 'text-muted' : ''}`}>{selectMultiMerchant.name}</li>
                        {displayMode === 'pic-log' && <li className="text-dark breadcrumb-item">{intl.formatMessage({ id: 'FORM.LABEL.MERCHANT_PIC_LOG' })}</li>}
                    </ol>
                </div>
                <div className="col-lg-6 col-sm-6 col-xl-6" style={{ textAlign: "right" }}>
                    <div className="d-flex float-end px-3">
                        {displayMode === 'pic-log' && user.data.is_superadmin &&
                            <DatePicker
                                format="dd MMM yyyy"
                                ranges={[]}
                                oneTap
                                value={date}
                                onChange={(value) => {
                                    if (value) {
                                        setDate(value)
                                    }
                                }}
                                style={{ width: 200, backgroundColor: "white" }}
                                shouldDisableDate={(date) => {
                                    return date > new Date();
                                }}
                                locale={calendarLocale}
                                placement="bottomEnd"
                                editable={false}
                            />
                        }
                        <div
                            onClick={() => {
                                mutate((displayMode === 'pic-log' && user.data.is_superadmin)
                                    ? `${API_URL}merchant-owner-movements?merchantTemplateId=${codeUrl}&dateCreated=${moment(date).format('YYYY-MM-DD')}`
                                    : `${API_URL}merchants${codeUrl ? `?merchantTemplateId=${codeUrl}`: ""}`)
                            }}
                            className="btn btn-light btn-sm ms-2"
                        >
                            <i className="p-0 fa-sync-alt fas"></i>
                        </div>
                    </div>
                </div>
            </div>
            {user.data.is_superadmin &&
                <div className={`d-flex justify-content-end`}>
                    <div className="d-flex align-items-center">
                        <ul className="nav nav-pills align-items-center mb-3" style={{ flexWrap: "unset" }}>
                            <li className="nav-item m-0" onClick={() => { setDisplayMode("table"); }}>
                                <a className={`btn btn-sm btn-icon btn-white me-3 ${displayMode === "table" ? "btn-primary" : "btn-active-light-primary"}`} data-bs-toggle="tab" href="#tab_table" >
                                    <span className="svg-icon svg-icon-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="black"></path>
                                            <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="black"></path>
                                        </svg>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item m-0" onClick={() => { setDisplayMode("pic-log"); }}>
                                <a className={`btn btn-sm btn-icon btn-white ${displayMode === "pic-log" ? "btn-primary" : "btn-active-light-primary"}`} data-bs-toggle="tab" href="#tab_pic-log" >
                                    <span className="svg-icon svg-icon-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M20.9 12.9C20.3 12.9 19.9 12.5 19.9 11.9C19.9 11.3 20.3 10.9 20.9 10.9H21.8C21.3 6.2 17.6 2.4 12.9 2V2.9C12.9 3.5 12.5 3.9 11.9 3.9C11.3 3.9 10.9 3.5 10.9 2.9V2C6.19999 2.5 2.4 6.2 2 10.9H2.89999C3.49999 10.9 3.89999 11.3 3.89999 11.9C3.89999 12.5 3.49999 12.9 2.89999 12.9H2C2.5 17.6 6.19999 21.4 10.9 21.8V20.9C10.9 20.3 11.3 19.9 11.9 19.9C12.5 19.9 12.9 20.3 12.9 20.9V21.8C17.6 21.3 21.4 17.6 21.8 12.9H20.9Z" fill="currentColor" />
                                            <path d="M16.9 10.9H13.6C13.4 10.6 13.2 10.4 12.9 10.2V5.90002C12.9 5.30002 12.5 4.90002 11.9 4.90002C11.3 4.90002 10.9 5.30002 10.9 5.90002V10.2C10.6 10.4 10.4 10.6 10.2 10.9H9.89999C9.29999 10.9 8.89999 11.3 8.89999 11.9C8.89999 12.5 9.29999 12.9 9.89999 12.9H10.2C10.4 13.2 10.6 13.4 10.9 13.6V13.9C10.9 14.5 11.3 14.9 11.9 14.9C12.5 14.9 12.9 14.5 12.9 13.9V13.6C13.2 13.4 13.4 13.2 13.6 12.9H16.9C17.5 12.9 17.9 12.5 17.9 11.9C17.9 11.3 17.5 10.9 16.9 10.9Z" fill="currentColor" />
                                        </svg>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            }
            {
                displayMode === 'pic-log' && user.data.is_superadmin ? (
                    <MerchantPICLog date={moment(date).format('YYYY-MM-DD')} merchantTitle={settings.merchant_title} merchantTemplateId={codeUrl!} />
                ) : (
                    <MasterDataTable
                        tableKey="merchants"
                        tableColumns={tableColumnsWithCustomFields}
                        actions={actions}
                        apiURL={`merchants${codeUrl ? `?merchantTemplateId=${codeUrl}` : ""}`}
                        orderBy={'dateCreated'}
                        order={'desc'}
                        onRowClicked={onRowClicked}
                        autoReload={false}
                    />
                )}

            {
                showAddReimbursementModal && <AddReimbursement merchant={merchant!} />
            }
            {
                showDetailModal && <DetailMerchant data={merchant!} redirectWhatsappValid={redirectWhatsappValid} redirectWhatsappNotValid={redirectWhatsappNotValid} />
            }
            {
                showUpdateModal && <UpdateMerchant merchant={merchant!} />
            }
            {
                showUpdatePhoneModal && <UpdatePhoneMerchant merchant={merchant!} />
            }
            {
                showDeleteModal && <DeleteMerchant merchant={merchant!} />
            }
            {
                showMergeModal && <MergeMerchant merchant={merchant!} column={tableColumnsWithCustomFields} />
            }
            {
                showAttachmentCustomField && <ModalAttachmentCustomField id={merchant!.id} title={customFields[key].name!} url={url} />
            }
        </>
    )
}

export { MasterMerchant }